module.exports = "<div *ngIf=\"visible\" class=\"rc-info\">\n  {{title}}\n</div>\n"